import React, { Component } from 'react';
import { connect } from 'react-redux';
// import Donut from "../../Doughnut2/index";
import {Grid} from '@material-ui/core'
import {isEmpty,isUndefined} from 'lodash'
import { getUtfalldiagramBarnKontoSkapadORderByAfid } from 'actions'
import {NumberFormat} from 'components/NotyNumberFormat'
import Skeleton from '@material-ui/lab/Skeleton';
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({auth,DashBoard, accountsData}) {
    const { authUser} = auth;
		const { Flags } = accountsData
    const { UtfallSdiagramBarnOrderKontor,DashboardBarnFilterOption} = DashBoard;
    return {
        authUser,UtfallSdiagramBarnOrderKontor,DashboardBarnFilterOption,Flags
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getUtfalldiagramBarnKontoSkapadORderByAfid: (Afid) => dispatch(getUtfalldiagramBarnKontoSkapadORderByAfid(Afid)),
        dispatch
    };
}

class NyaOrder extends Component {
    state={
        UtfallSdiagram:{utfall:0,budget:100},
        DashboardBarnFilterOption:isEmpty(this.props.DashboardBarnFilterOption)?[]:this.props.DashboardBarnFilterOption,
        done: false
    }
    intervalID = null
    componentDidMount=()=>{
        const Afid = this.props.Afid;
        this.props.getUtfalldiagramBarnKontoSkapadORderByAfid(Afid).then(() => { 
            this.initiateInterval()
            this.setState({done: true})
         })       
    }
    initiateInterval () {
        clearInterval(this.intervalID);
        this.intervalID = null 
        this.intervalID = setInterval(
            () => {
                if(this.state.done === true){ 
                    this.setState({done: false,})
                    const Afid = this.props.Afid;
                    this.props.getUtfalldiagramBarnKontoSkapadORderByAfid(Afid).then(() => { 
                        this.initiateInterval()
                        this.setState({done: true})
                     })
                }
            },
            30000
        );
      }
    componentWillUnmount() {
        clearInterval(this.intervalID);
        this.intervalID = null
    }
    formatNumber=(number)=>{
      return NumberFormat(number, this.props.Flags?.DashboardRoundoff === 0 ? 'standard' : 'compact', 'auto', 0)
        console.log(number)
        if(number > 1000000){
            return `${(number/1000000).toFixed(0)}M`
        }else if(number >= 1000){
            return `${(number/1000).toFixed(0)}K`
        }else{
            return number
        }
    }
    componentDidUpdate=()=>{
        if(!isUndefined(this.props.UtfallSdiagramBarnOrderKontor)){
            if(this.props.UtfallSdiagramBarnOrderKontor !== this.state.UtfallSdiagram){
                this.setState({
                    UtfallSdiagram:this.props.UtfallSdiagramBarnOrderKontor
                })
            }
        }
        if(this.props.DashboardBarnFilterOption !== this.state.DashboardBarnFilterOption && !isEmpty(this.props.DashboardBarnFilterOption))
        {
            this.setState({ done:false })
            const Afid = this.props.Afid;
            this.props.getUtfalldiagramBarnKontoSkapadORderByAfid(Afid).then(() => { 
                this.initiateInterval()
                this.setState({done: true})
             }) /**/
            this.setState({
                DashboardBarnFilterOption:this.props.DashboardBarnFilterOption 
            }) 
        }
    }
    render() {
        console.log(this.props.UtfallSdiagramBarnOrderKontor)
        let TopKontor = isEmpty(this.props.UtfallSdiagramBarnOrderKontor)?{
            name:"-",
            total:0,
            CountTotal:0
        }:
        this.props.UtfallSdiagramBarnOrderKontor[0]
        let totalVarde= 0
        if(!isEmpty(this.props.UtfallSdiagramBarnOrderKontor)){
            for(let item of this.props.UtfallSdiagramBarnOrderKontor){
                totalVarde += parseInt(item.total)
            }
        }
        return (
           <div className='d-flex flex-column justify-content-between align-items-center h-100 p-3'>
						<div>
								<h2 style={{ paddingTop: '12px', fontWeight: 500, lineHeight: 1.2, color: '#fff' }}><IntlMessages id="DashBoard.New.Order.No1"/></h2>
						</div>
            
								{
							this.state.done === false?
							<Skeleton variant="rectangular" height={60} width={'150px'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
							:
										<p style={{ fontSize:this.props.size === 100 ? 50 : 60, fontWeight:"500", color: '#44D1C2', '-webkit-text-stroke': '2px #54F3E3' }}>
													{this.formatNumber(totalVarde)}                   
									</p>
									}
					
								{
							this.state.done === false?
							<Skeleton variant="rectangular" height={60} width={'150px'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
							:
							<div className="d-flex   align-items-end justify-content-between w-100 text-white" >
							<h3 style={{ paddingTop: '12px', fontWeight: 500, lineHeight: 1.2 }}>{TopKontor.name}</h3>
							<p style={{ lineHeight: 1.2 }}>{this.formatNumber(TopKontor.total)}/<samll>{TopKontor.CountTotal}st</samll></p>
							</div>}
                
            </div>

        );
    }
}

export default connect(
    mapStateToProps,mapDispatchToProps
)(NyaOrder);